var angular = require('angular');

import licenseModule from '../../license.module';

export default licenseModule.component('licenseServer', {
    template: require('./licenseServer.component.html'),
    styleUrls: require('./licenseServer.component.css'),
    controller: ['LicenseManagementService', licenseServerComponent],
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

function licenseServerComponent(LicenseManagementService) {
    var vm = this;
    vm.processing = false;

    vm.$onInit = function() {
        vm.valid = false;
        vm.data = angular.copy(vm.resolve.data);
        vm.navs = [
            {
                label: 'Server Details',
                value: 'server-details',
                component: 'licenseServerDetails',
                resolve: {
                    name: vm.data.name,
                    description: vm.data.serverDescription,
                    countryCode: vm.data.countryCode
                },
                callback: function(value) {
                    vm.valid = true;
                    vm.data.name = value.name;
                    vm.data.serverDescription = value.description;
                    vm.data.countryCode = value.countryCode;
                }
            },
            {
                label: 'Server Profile',
                value: 'server-profile',
                component: 'licenseServerProfile',
                resolve: {
                    id: vm.data.id
                },
                callback: function(value) {
                    vm.valid = true;
                    vm.data.serverProfile = value;
                }
            }
        ];
        vm.options = {
            workflow: false
        };
        vm.currentWorkflow = vm.navs[0];
    };

    vm.getDisabled = function() {
        if (vm.currentWorkflow != undefined) {
            if (vm.currentWorkflow.value == 'server-details') {
                if (vm.data.name === undefined) {
                    return true;
                }
                return (
                    vm.data.name.length > 100 ||
                    (vm.data.serverDescription !== undefined &&
                        vm.data.serverDescription.length > 100)
                );
            }
            return false;
        }
    };

    vm.cancel = function() {
        if (!vm.processing) {
            vm.dismiss({ $value: 'cancel' });
        }
    };

    vm.apply = function() {
        var instance = {
            name: vm.data.name,
            description: vm.data.serverDescription,
            countryCode: vm.data.countryCode,
            payload: vm.data.serverProfile
        };

        if (!vm.processing) {
            vm.processing = true;
            setTimeout(function() {
                LicenseManagementService.updateInstance(
                    vm.data.id,
                    instance
                ).then(
                    function() {
                        vm.close({ $value: instance });
                    },
                    function() {
                        vm.close({ $value: instance });
                    }
                );
            }, 10000);
        }
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-server/licenseServer.component.js